export const MedicalInterview = {
  MedicalInterviewCard: {
    SubMessage:
      '問診票を事前に記入していただくと、調剤やお薬の説明がスムーズになります。',
    ButtonTitle: '事前問診に記入する',
    ReservationDateTimeTitle: '予約日時：',
  },
  // 画面タイトル
  Title: {
    BSC_HC_040_006: '病気',
    BSC_HC_040_007: 'アレルギー',
    BSC_HC_040_008: '副作用',
    BSC_HC_040_010: '服薬中のお薬',
    BSC_HC_040_011: 'よく摂取するもの',
    BSC_HC_040_012: '苦手な形状のお薬',
    BSC_HC_040_013: 'その他当てはまるもの',
    BSC_HC_040_015: '妊娠・授乳',
    BSC_HC_060_010: '問診票の記入',
  },
  Message: {
    ExplanationWrite: '以下の情報を入力し、「回答する」を押してください。',
    BSC_HC_040_006_Caption:
      'かかったことのある病気、または治療中の病気があればチェックを付けてください。',
    BSC_HC_040_007_Caption:
      'アレルギーをお持ちの方は、チェックを付けてください。',
    BSC_HC_040_008_Caption:
      'お薬の副作用で当てはまるものに、チェックを付けてください。',
    BSC_HC_040_010_Caption: 'お薬情報を入力してください。',
    BSC_HC_040_011_Caption:
      'よく摂取するもので当てはまるものに、チェックを付けてください。',
    BSC_HC_040_012_Caption:
      '苦手な形状のお薬で当てはまるものに、チェックを付けてください。',
    BSC_HC_040_013_Caption:
      'その他当てはまるものに、チェックを付けてください。',
    BSC_HC_040_015_Caption: '当てはまるものに、チェックを付けてください。',
    SicknessOther: 'その他の病気があればご記入ください。',
    AllergyOther: 'その他のアレルギーがあればご記入ください。',
    SideEffectOther: 'その他の副作用や薬剤名があればご記入ください。',
    TakingMedicineOther:
      'お薬手帳に記載がない服薬中のお薬、市販薬、サプリメント、漢方などがあれば入力してください。',
    AnoutNothing: '特にない場合、空欄のままにしてください。',
    OtherPlaceholder: '500文字以内でご入力ください。',
    ConfirmPostMedicalInterview: '問診票を薬局に提出してよろしいですか？',
    ConfirmCancelEditMedicalInterview:
      '問診票は提出されませんがよろしいですか？',
    ConfirmCancelEditMedicalInterviewSingleItem:
      '変更内容は更新されませんがよろしいですか？',
    NotSelectedItem: '項目が選択されていません。',
  },
  Label: {
    Sickness: 'かかったことのある病気、または治療中の病気',
    Allergy: 'アレルギー',
    SideEffect: '副作用',
    TakingMedicine: '服薬中のお薬',
    Pregnancy: '妊娠・授乳',
    LuxuryItem: 'よく摂取するもの',
    WeakShape: '苦手な形状のお薬',
    Other: 'その他',
  },
  OverviewLabel: {
    NO_ANSWER: '未回答',
    NO_CHECKED: '特になし',
    NOTHING: 'なし',
  },
  SicknessKind: {
    _01_Stroke: '脳梗塞',
    _02_Epilepsy: 'てんかん',
    _03_Dementia: '認知症',
    _04_Angina: '狭心症',
    _05_Arrhythmia: '不整脈',
    _06_LiverFailure: '肝機能障害',
    _07_RenalFailure: '腎機能障害',
    _08_HighBlood: '高血圧症',
    _09_Type1Diabetes: '１型糖尿病',
    _10_Type1Diabetes: '２型糖尿病',
    _11_Hyperlipidemia: '脂質異常症',
    _12_Nephritis: '腎炎・消化性腫瘍',
    _13_BronchialAsthma: '気管支喘息',
    _14_Osteoporosis: '骨粗鬆症',
    _15_ProstaticHyperplasia: '前立腺肥大症',
    _16_Glaucoma: '緑内障',
    _17_Cataract: '白内障',
    _18_Rhinitis: '鼻炎・花粉症',
    _19_Ventilation: '痛風',
    _20_StomachUlcer: '胃・十二指腸潰瘍',
    _21_Cancer: 'がん',
    __Other: 'その他',
  },
  AllergyKind: {
    _01_Egg: '卵',
    _02_Milk: '牛乳',
    _03_Alcohol: 'アルコール',
    _04_Iodine: 'ヨード',
    _06_Gelatin: 'ゼラチン',
    _07_Wheat: '小麦',
    __Other: 'その他',
  },
  SideEffectKind: {
    _01_Dizzy: 'めまい',
    _02_Diarrhea: '下痢',
    _03_Constipation: '便秘',
    _04_Nausea: '吐き気',
    _05_Rash: '発疹',
    _06_Stomachache: '腹痛',
    _07_Thirst: '口渇',
    _08_Sleepiness: '眠気',
    _09_Headache: '頭痛',
    __Other: 'その他',
  },
  PregnancyKind: {
    _01_Pregnant: '妊娠している、その可能性がある',
    _01_PregnantShort: '妊娠中',
    _01_WhenPregnant: 'いつから妊娠されていますか？',
    _01_SelectDateFormat: '{year}年{month}月',
    _02_Breastfeeding: '授乳中である',
    _02_BreastfeedingShort: '授乳中',
  },
  LuxuryItemKind: {
    _01_Dairy: '乳製品',
    _02_Coffee: 'コーヒー',
    _03_Natto: '納豆',
    _04_GrapeFruit: 'グレープフルーツジュース',
    _05_GreenJuice: '青汁',
    _06_Chlorella: 'クロレラ',
  },
  WeakShapeKind: {
    _01_Powder: '粉薬',
    _02_Syrup: 'シロップ',
    _03_Capsule: 'カプセル',
    _04_Tablet: '錠剤',
  },
  OtherKind: {
    Category: {
      _01_Habits: '習慣',
      _02_Constitution: '体質',
      _03_EatingHabits: '食生活',
    },
    _01_01_Drive: '運転をする',
    _01_02_Smoking: '喫煙する',
    _01_02_Smoking_PreInput: '1日',
    _01_02_Smoking_PostInput: '本',
    _01_03_AlcOccasionally: 'お酒を飲む',
    _01_04_AlcEveryday: 'お酒を毎日飲む',
    _01_05_DangerousSports: '危険なスポーツをする',
    _01_06_UnExercise: 'あまり運動をしない',
    _01_07_WorkHeight: '高所作業・危険な機械の操作をする',
    _01_08_ContactLenses: 'コンタクトレンズ着用',
    _02_09_Rash: 'かぶれやすい',
    _02_10_Constipation: '便秘がち',
    _02_11_Diarrhea: '下痢しやすい',
    _02_12_StomachWeak: '胃が弱い',
    _03_13_IrregularMeals: '食事が不規則',
    _03_14_SkipMeals: '食事を抜くことが多い',
    _03_15_EatFast: '食べるのが早い',
    _03_16_LotsOfSnack: '間食が多い',
    _03_17_LotsOfSweets: '甘いものをよく食べる',
    _03_18_LotsOfGreasy: '油っぽいものをよく食べる',
    _03_19_LotsOfSalty: '塩気の強いものが好き',
    _03_20_GotoBet: '夕食後すぐに就寝',
  },
  ButtonLabel: {
    WriteFinish: '回答する',
    Update: '更新する',
  },
};
